import { type FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoute } from '@common/app/routes';
import { useCountDownTimer } from '@common/hooks/count-down-timer';
import { type ActiveBoostItemProps } from '@common/types/components';
import { useModal } from '@context/ModalContext';
import { clearFactoryBoost } from '@redux/reducers/factoryReducer';
import { selectFactoryByIdOrName } from '@redux/selectors/factoryReducer';
import { useAppDispatch, useAppSelector } from '@redux/store';

import { ActiveBoostItem } from '../ActiveBoostItem';

const FactoryActiveBoostItem: FC<ActiveBoostItemProps> = ({
  id,
  expiresInSeconds,
  plantId,
  boostType,
  effectMultiplier,
}) => {
  const dispatch = useAppDispatch();
  const factory = useAppSelector((state) => selectFactoryByIdOrName(state, id));
  const seconds = useCountDownTimer(expiresInSeconds);
  const navigate = useNavigate();
  const { setIsFactoryBoostModalOpen } = useModal();

  useEffect(() => {
    if (seconds === 0 && seconds !== expiresInSeconds) {
      dispatch(clearFactoryBoost({ plantId, boostType }));
    }
  }, [expiresInSeconds, seconds]);

  const onClick = (): void => {
    navigate(AppRoute.FACTORY + `/${id}`);
    setIsFactoryBoostModalOpen(false);
  };

  if (!factory || !expiresInSeconds) {
    return null;
  }

  return (
    <div onClick={onClick}>
      <ActiveBoostItem
        seconds={seconds}
        itemName={factory.name}
        effectMultiplier={effectMultiplier}
      />
    </div>
  );
};

export { FactoryActiveBoostItem };
